export default __webpack_public_path__ + "img/eb27c18b2356fb3652d40941db849433.png";